import module from 'contabilidad/polizasexternas/module'

export class PolizasExternasAlgodonerosFacturasService {
  constructor($http) {
    this.$http = $http
  }

  get(movimientoId) {
    return this.$http.get('/api/contabilidad/polizasexternas/algodoneros/movimiento/facturas', {
      params: { movimientoId },
      schema: { fecha: 'date', importe: 'number' }
    })
  }

  delete(movimientoId, facturaId, importe) {
    return this.$http.delete('/api/contabilidad/polizasexternas/algodoneros/movimiento/facturas', {
      params: { movimientoId, facturaId, importe },
      schema: { importe: 'number' }
    })
  }
}

module.service('PolizasExternasAlgodonerosFacturasService', PolizasExternasAlgodonerosFacturasService)


// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/services/Algodoneros/Facturas.js